import { commodityConstants } from '../../_constants';

export function commodity(state = {}, action) {
    switch (action.type) {
        case commodityConstants.RESET:
            return {};
        case commodityConstants.COMMODITY_FETCHING:
            return {
                ...state,
                commodityFetching: true
            };
        case commodityConstants.COMMODITY_FETCHED:
            return {
                ...state,
                commodityFetching: false
            };
        case commodityConstants.COMMODITY_SUBMITTING:
            return {
                ...state,
                commoditySubmitting: true
            };
        case commodityConstants.COMMODITY_SUBMITTED:
            return {
                ...state,
                commoditySubmitting: false
            };
        case commodityConstants.COMMODITIES:
            return {
                ...state,
                commodities: action.commodities,
            };
        case commodityConstants.COMMODITY:
            return {
                ...state,
                commodity: action.commodity
            };
        default:
            return state;
    }
}